import React,{useState} from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, ExpansionPanel, IconButton, Typography} from '../ui/core'
import {Close} from '../ui/coreIcons'
export default function DialogFAQ({FAQs,onClose}) {
    const [currentQuestion,setCurrentQuestion] = useState()

    const createDOMPurify = require('dompurify');
    const DOMPurify = createDOMPurify(window);
    return (
        <Dialog onClose={onClose} fullScreen>
            <DialogTitle>
                <Typography component="h1">Veelgestelde vragen</Typography>
                {onClose && <IconButton onClick={onClose} style={{position:'absolute', right:'64px', top:'10px'}}><Close/></IconButton>}
            </DialogTitle>
            <DialogContent>
                {FAQs.map(faq=>{
                    return   <ExpansionPanel key={faq._id} primary={<Typography component="h3">{faq.question}</Typography>} expanded={faq._id===currentQuestion} onClick={()=>{faq._id!==currentQuestion?setCurrentQuestion(faq._id):setCurrentQuestion()}}>
                    <div style={{padding:'20px'}}  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(faq.answer) }} ></div>
                                </ExpansionPanel>
                })}
          
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} style={{backgroundColor:'#ff6A13'}}>Venster sluiten</Button>
            </DialogActions>
        </Dialog>
    )
}
